"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    "FRIDAY": "vrijdag",
    "MONDAY": "maandag",
    "SATURDAY": "zaterdag",
    "SUNDAY": "zondag",
    "THURSDAY": "donderdag",
    "TUESDAY": "Dinsdag",
    "WEDNESDAY": "woensdag",
    "and": "en",
    "day": "dag",
    "day_one": "dag",
    "day_other": "dagen",
    "day_plural": "dagen",
    "freeOfCharge": "Gratis",
    "hour_one": "uur",
    "hour_one_plural": "uur",
    "hour_other": "uur",
    "minute": "minuut",
    "minute_one": "minuut",
    "minute_other": "minuten",
    "ocpiRestrictionsAfterDuration": "Na {{minDuur}}",
    "ocpiRestrictionsBetweenDuration": "Tussen {{minDuration}} en {{maxDuration}}",
    "ocpiRestrictionsFirstDuration": "Eerste {{maxDuration}}",
    "ocpiRestrictionsKwhAbove": "Bij energieverbruik boven {{minKwh}}",
    "ocpiRestrictionsKwhBetween": "Wanneer energieverbruik tussen {{minKwh}} en {{maxKwh}}",
    "ocpiRestrictionsKwhLessThan": "Wanneer energieverbruik minder dan {{maxKwh}}",
    "session": "sessie",
    "theDay": "dag",
    "theDay_one": "dag",
    "theDay_other": "dagen",
    "theHour": "uur",
    "theHour_one": "uur",
    "theHour_other": "uur",
    "theMinute": "minuut",
    "theMinute_one": "minuut",
    "theMinute_other": "minuten"
};
